import { Subject } from 'rxjs';

export type AlertTypes =
  | 'warning'
  | 'success'
  | 'isLoading'
  | 'error'
  | 'info'
  | undefined;

interface IAlert {
  message: string;
  type: AlertTypes;
  onClose?: () => void;
}

const alertSubject = new Subject<IAlert>();

export const AlertService = alertSubject.asObservable();

export const feedback = (
  message: string,
  type: AlertTypes,
  onClose?: () => void,
) => {
  alertSubject.next({
    message,
    onClose,
    type,
  });
};

export const finishRequest = (message: string, feedbackType: AlertTypes, onSuccess?: () => void) => {
  feedback(message, feedbackType);

  if (feedbackType === 'success' && onSuccess) {
    onSuccess();
  }
};
